import { getExtensionId, waitForExtensionId } from '../services/extensionId';

// Resolves the target origin for window.parent.postMessage when the
// portal is embedded in the Percix chrome-extension's side panel. The
// extension stamps its id onto `<html data-percix-extension-id="…">`;
// the parent page's origin is `chrome-extension://<id>`.
//
// Returns undefined when the id isn't available — caller should skip
// the postMessage rather than broadcast with '*'.
export function getParentTargetOrigin(): string | undefined {
  const id = getExtensionId();
  return id ? `chrome-extension://${id}` : undefined;
}

// Async variant: waits up to ~800ms for the bridge content script to
// stamp the id. Use this on early mount paths where the script may not
// have run yet; use the sync variant after user interaction.
export async function waitForParentTargetOrigin(): Promise<string | undefined> {
  const id = await waitForExtensionId();
  return id ? `chrome-extension://${id}` : undefined;
}
